import clsx from 'clsx'

import { Icon } from '@wartek-id/icon-v2'
import { Text } from '@wartek-id/text-v1'

import {
  CONFIG_MATCH_AND_DELIVERED,
  CONFIG_MATCH_AND_NOT_DELIVERED,
  CONFIG_UNOR_UNMATCH,
  CONFIG_UNOR_UNMATCH_ORG,
  CONFIG_UNOR_UNMATCH_SUPERIOR,
} from './states'

import type { CardParams } from './states'
import type { KonfirmasiUnorStatus, TipePengaliranStatus } from 'types/kinerja'

const getConfig = (
  pengaliranStatus: TipePengaliranStatus,
  unorStatus: KonfirmasiUnorStatus
): CardParams | undefined => {
  if (unorStatus === 'UNOR_MATCH') {
    if (pengaliranStatus === 'DELIVERED') {
      return CONFIG_MATCH_AND_DELIVERED
    }

    if (pengaliranStatus === 'NOT_DELIVERED') {
      return CONFIG_MATCH_AND_NOT_DELIVERED
    }
  }

  if (unorStatus === 'UNOR_UNMATCH_ORG') {
    return CONFIG_UNOR_UNMATCH_ORG
  }

  if (unorStatus === 'UNOR_UNMATCH_SUPERIOR') {
    return CONFIG_UNOR_UNMATCH_SUPERIOR
  }

  if (unorStatus === 'UNOR_UNMATCH') {
    return CONFIG_UNOR_UNMATCH
  }

  return undefined
}

interface CardPengaliranKinerjaStatusProps {
  statusUnor: KonfirmasiUnorStatus
  statusPengaliran: TipePengaliranStatus
}

export default function CardPengaliranKinerjaStatus({
  statusUnor,
  statusPengaliran,
}: CardPengaliranKinerjaStatusProps) {
  const config = getConfig(statusPengaliran, statusUnor)

  if (config === undefined) {
    return null
  }

  return (
    <div
      data-testid="card-pengaliran-kinerja-status"
      className={clsx('rounded border p-3 flex gap-3', config.cardClasses)}
    >
      <Icon>{config.icon}</Icon>

      <div className="flex flex-col gap-1">
        <Text variant="heading-sm">{config.title}</Text>

        <Text>{config.subtitle}</Text>

        {config.CtaSection && (
          <div className="flex gap-1">
            <config.CtaSection />
          </div>
        )}
      </div>
    </div>
  )
}
